import { PayloadAction } from "@reduxjs/toolkit";
import api from "../../Axios/middleware";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import { failureListRoleScreenYGPermission, successListRoleScreenYGPermission, RoleScreenYGPermissionParams } from "./ListRoleScreenYGPermissionSlice";
import {
    ManageRoleScreenYGPermissionPayload,
    successManageRoleScreenYGPermission,
    failureManageRoleScreenYGPermission
} from "./ManageRoleScreenYGPermissionSlice";

const getRoleScreenYGPermissionListApi = (action: PayloadAction<RoleScreenYGPermissionParams>) => {
    const { role_id, yeargroup_country_map_id } = action.payload;
    return api.get(`/api/role-screen-yg-permission/role/${role_id}/screens`, {
        params: {
            yeargroup_country_map_id
        }
    });
};

const manageRoleScreenYGPermissionApi = (action: PayloadAction<ManageRoleScreenYGPermissionPayload>) => {
    const { role_id, yeargroup_country_map_id, permissions } = action.payload;
    return api.post(`/api/role-screen-yg-permission/manage/${role_id}`, {
        permissions
    }, {
        params: {
            // If yeargroup_country_map_id is null/undefined, sending it might be okay or handled by backend as "common".
            // The requirement says "If NULL -> Manages common". Axios params with null/undefined might skip the key.
            // Explicitly checking if it has a value or force sending null if needed.
            // Assuming strict check:
            yeargroup_country_map_id: yeargroup_country_map_id
        }
    });
};

export function* RoleScreenYGPermissionSaga(action: PayloadAction<RoleScreenYGPermissionParams>) {
    try {
        const response: AxiosResponse = yield call(getRoleScreenYGPermissionListApi, action);
        yield put(successListRoleScreenYGPermission(response.data));
    } catch (error) {
        yield put(failureListRoleScreenYGPermission(error));
    }
}

export function* ManageRoleScreenYGPermissionSaga(action: PayloadAction<ManageRoleScreenYGPermissionPayload>) {
    try {
        const response: AxiosResponse = yield call(manageRoleScreenYGPermissionApi, action);
        yield put(successManageRoleScreenYGPermission(response.data));
    } catch (error) {
        yield put(failureManageRoleScreenYGPermission(error));
    }
}
